import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function Shop() {
  const [sp] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [cats, setCats] = useState([]);
  const [sort, setSort] = useState("newest");
  const [category, setCategory] = useState(sp.get("category") || "all");
  const [q, setQ] = useState(sp.get("q") || "");
  const [priceMax, setPriceMax] = useState(50000);

  useEffect(() => { api.get("/products/categories").then((r) => setCats(r.data)); }, [api]);
  useEffect(() => {
    const params = new URLSearchParams();
    if (category !== "all") params.set("category", category);
    if (q) params.set("q", q);
    params.set("sort", sort);
    if (sp.get("featured")) params.set("featured", "true");
    if (sp.get("bestseller")) params.set("bestseller", "true");
    if (sp.get("new_arrival")) params.set("new_arrival", "true");
    params.set("max_price", priceMax);
    api.get(`/products?${params.toString()}`).then((r) => setProducts(r.data));
  }, [category, q, sort, priceMax, sp, api]);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 fade-up">
      <div className="text-center mb-12">
        <p className="eyebrow">The Boutique</p>
        <h1 className="font-serif text-4xl md:text-6xl mt-3">Shop All</h1>
      </div>
      <div className="grid md:grid-cols-[240px_1fr] gap-10">
        <aside className="space-y-8">
          <div>
            <h4 className="text-xs uppercase tracking-[0.25em] mb-4">Category</h4>
            <div className="space-y-2 text-sm">
              <button onClick={() => setCategory("all")} className={`block ${category === "all" ? "text-[#C5A059]" : "text-[#55524D]"}`} data-testid="filter-cat-all">All</button>
              {cats.map((c) => (
                <button key={c} onClick={() => setCategory(c)} className={`block ${category === c ? "text-[#C5A059]" : "text-[#55524D]"}`} data-testid={`filter-cat-${c}`}>{c}</button>
              ))}
            </div>
          </div>
          <div>
            <h4 className="text-xs uppercase tracking-[0.25em] mb-4">Max Price</h4>
            <input type="range" min="2000" max="50000" step="1000" value={priceMax} onChange={(e) => setPriceMax(+e.target.value)} className="w-full" data-testid="filter-price-max" />
            <p className="text-xs text-[#8C867D] mt-2">Up to ₹{priceMax.toLocaleString("en-IN")}</p>
          </div>
        </aside>
        <div>
          <div className="flex items-center justify-between mb-8">
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search" className="border-b border-[#E2DDD5] bg-transparent px-2 py-1 text-sm focus:outline-none focus:border-[#C5A059] w-64" data-testid="shop-search" />
            <select value={sort} onChange={(e) => setSort(e.target.value)} className="border border-[#E2DDD5] bg-transparent px-3 py-2 text-xs uppercase tracking-widest" data-testid="shop-sort">
              <option value="newest">Newest</option>
              <option value="price_asc">Price: Low to High</option>
              <option value="price_desc">Price: High to Low</option>
              <option value="popular">Popularity</option>
            </select>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-10">
            {products.map((p) => <ProductCard key={p.id} p={p} />)}
          </div>
          {products.length === 0 && <p className="text-center text-[#8C867D] py-20">No products found.</p>}
        </div>
      </div>
    </div>
  );
}
